/**
 * @flow
 */

import React from 'react';

import {
  InputCheckBox,
  CheckBox,
  LabelCheckBox,
} from './CheckboxStyled';

type CheckboxViewPropsType = {
  message: any;
  status?: boolean;
  setCheck: (any) => void,
  onClickItem: (any) => void,
  disabled: boolean,
};

export default function CheckboxView(props: CheckboxViewPropsType) {
  return (
    <CheckBox
      onClick={() => {
        props.setCheck(!props.status);
        props.onClickItem(!props.status);
      }}
      disabled={props.disabled}
    >
      <InputCheckBox status={props.status} />
      <LabelCheckBox>{props.message}</LabelCheckBox>
    </CheckBox>
  );
}

CheckboxView.defaultProps = {
  status: false,
};
